'use client';

import { IconName } from '@swisscom/sdx';
import cx from 'classnames';
import { HTMLAttributes, MouseEvent, RefObject } from 'react';

type RequiredProps = {
  name: IconName;
};

type OptionalProps = {
  size?: IconSize;
  className?: string;
  style?: HTMLAttributes<HTMLSpanElement>['style'];
  onClick?: (event: MouseEvent<HTMLSpanElement>) => void;
  ref?: RefObject<HTMLSpanElement>;
};

type IconSize = 1 | 2 | 3 | 4 | 5 | 6;

const Icon: React.FC<RequiredProps & OptionalProps> = ({
  name,
  size,
  className,
  style,
  onClick,
  ref,
}) => {
  return (
    <span
      ref={ref}
      style={{ ...style, ...(onClick ? { cursor: 'pointer' } : {}) }}
      aria-hidden
      onClick={onClick}
      className={cx(
        'icon',
        name,
        {
          [`icon--s${size}`]: size != undefined,
        },
        className,
      )}
    />
  );
};

export default Icon;
export type { IconSize };
